import React from 'react'
import styled from 'styled-components'
import { Link } from 'blocket-ui'

// https://accessibility.oit.ncsu.edu/it-accessibility-at-nc-state/developers/accessibility-handbook/mouse-and-keyboard-events/skip-to-main-content/
const StyledLink = styled(Link)`
  position: absolute;
  top: 0;
  left: -9999px;
  width: 0px;
  height: 0px;
  overflow: hidden;

  &:focus,
  &:active {
    position: unset;
    top: auto;
    left: auto;
    width: auto;
    height: auto;
    overflow: unset;
  }
`

const SkipLink = ({ ...props }) => (
  // external seems to be what work when you want links to elements #id
  <StyledLink {...props} external>
    Gå direkt till innehållet
  </StyledLink>
)

export default SkipLink
